import React from 'react'
import './styles.scss'

const Image = ({component}: any) => {
  if(!component.url) return <></>
  const style = {
    width: component.width ? component.width : 'auto'
  }
  return (
    <div className="image_component" id={component.id}>
        <img style={style} src={component.url} alt={component.name}/>
    </div>
  )
}

export default Image
